import { render, staticRenderFns } from "./Desc.vue?vue&type=template&id=9ff5fbc6&"
import script from "./Desc.vue?vue&type=script&lang=js&"
export * from "./Desc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports